<template>
  <div class="footer2">
    <div class="box">
      <div class="tit">{{ $t('add.aboutus') }}</div>
      <ul>
        <li @click="handleRoute('/user/aboutus')">{{ $t('add.aboutus') }}</li>
      </ul>
    </div>
    <div class="box">
      <div class="tit">{{ $t('resource') }}</div>
      <ul>
        <li @click="handleRoute('/user/nftlist')">{{ $t('krazenft') }}</li>
        <li @click="handleRoute('/user/actcategory')">{{ $t('add.games') }}</li>
      </ul>
    </div>
    <div class="box">
      <div class="tit">{{ $t('contact') }}</div>
      <ul>
        <li>
          <a href="mailto:info@krazefootball.com" target="_blank"
            >info@krazefootball.com</a
          >
        </li>
      </ul>
    </div>
    <div class="box">
      <div class="tit">{{ $t('agreementpage.text7') }}</div>
      <ul>
        <li @click="handleRoute('/user/agreement')">
          {{ $t('privacypolicy') }}
        </li>
      </ul>
    </div>
    <div class="icon-block" style="justify-content: left">
      <div class="icon telegram1">
        <a
          v-if="$store.state.lang === 'en'"
          href="https://t.me/KrazeOfficial"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'ja'"
          href="https://t.me/KrazeOfficial"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'cn'"
          href="https://t.me/+pUJo0P7S4NM5YTZl"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'vi'"
          href="https://t.me/KrazeOfficial"
          target="_blank"></a>
      </div>
      <div class="icon photo1">
        <a
          v-if="$store.state.lang === 'en'"
          href="https://instagram.com/krazefootball?igshid=YmMyMTA2M2Y="
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'ja'"
          href="https://instagram.com/krazefootball?igshid=YmMyMTA2M2Y="
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'cn'"
          href="https://instagram.com/krazefootball?igshid=YmMyMTA2M2Y="
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'vi'"
          href="https://instagram.com/krazefootball?igshid=YmMyMTA2M2Y="
          target="_blank"></a>
      </div>
      <div class="icon twitter1">
        <a
          v-if="$store.state.lang === 'en'"
          href="https://twitter.com/krazefootball?s=21&t=HYXgV3dboPj9hUXSMk1Qjg"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'ja'"
          href="https://twitter.com/krazefootball?s=21&t=HYXgV3dboPj9hUXSMk1Qjg"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'cn'"
          href="https://twitter.com/krazefootball?s=21&t=HYXgV3dboPj9hUXSMk1Qjg"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'vi'"
          href="https://twitter.com/krazefootball?s=21&t=HYXgV3dboPj9hUXSMk1Qjg"
          target="_blank"></a>
      </div>
      <div class="icon discord1">
        <a
          v-if="$store.state.lang === 'en'"
          href="https://discord.gg/GhngJ2ab9R"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'ja'"
          href="https://discord.gg/GhngJ2ab9R"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'cn'"
          href="https://discord.gg/GhngJ2ab9R"
          target="_blank"></a>
        <a
          v-if="$store.state.lang === 'vi'"
          href="https://discord.gg/GhngJ2ab9R"
          target="_blank"></a>
      </div>
    </div>
    <div class="copright">© 2021-2022 {{ $t('copright') }}</div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {}
  },
  methods: {
    handleRoute(path) {
      this.$router.push({ path: path })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Resource.vue